import { ReactComponent as Mote } from 'icons/mote.svg';
import { ReactComponent as MoteColored } from 'icons/mote_colored.svg';

import { SvgIcon } from '@mui/material';

export const MoteIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <Mote />
        </SvgIcon>
    );
}

export const MoteColoredIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <MoteColored />
        </SvgIcon>
    );
}

export const MoteSecondaryColoredIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <MoteColored />
        </SvgIcon>
    );
}